module.exports = __webpack_public_path__ + "static/img/8.77bc1e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/8.jpg
// module id = YYOy
// module chunks = 1